/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pre-op-sign-in.reducer';

export const PreOpSignInUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const preOpSignInEntity = useAppSelector(state => state.preOpSignIn.entity);
  const loading = useAppSelector(state => state.preOpSignIn.loading);
  const updating = useAppSelector(state => state.preOpSignIn.updating);
  const updateSuccess = useAppSelector(state => state.preOpSignIn.updateSuccess);

  const handleClose = () => {
    navigate(`/pre-op-sign-in${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
    dispatch(getNurses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...preOpSignInEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      anaesthesiologist: doctors.find(it => it.id.toString() === values.anaesthesiologist?.toString()),
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...preOpSignInEntity,
          surgery: preOpSignInEntity?.surgery?.id,
          anaesthesiologist: preOpSignInEntity?.anaesthesiologist?.id,
          nurse: preOpSignInEntity?.nurse?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.preOpSignIn.home.createOrEditLabel" data-cy="PreOpSignInCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.preOpSignIn.home.createOrEditLabel">Create or edit a PreOpSignIn</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pre-op-sign-in-id"
                  label={translate('tinyMedicRestApp.preOpSignIn.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.patientConfirmation')}
                id="pre-op-sign-in-patientConfirmation"
                name="patientConfirmation"
                data-cy="patientConfirmation"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.identity')}
                id="pre-op-sign-in-identity"
                name="identity"
                data-cy="identity"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.siteAndSide')}
                id="pre-op-sign-in-siteAndSide"
                name="siteAndSide"
                data-cy="siteAndSide"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.procedure')}
                id="pre-op-sign-in-procedure"
                name="procedure"
                data-cy="procedure"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.consent')}
                id="pre-op-sign-in-consent"
                name="consent"
                data-cy="consent"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.siteMarked')}
                id="pre-op-sign-in-siteMarked"
                name="siteMarked"
                data-cy="siteMarked"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.anaesthesiaCheck')}
                id="pre-op-sign-in-anaesthesiaCheck"
                name="anaesthesiaCheck"
                data-cy="anaesthesiaCheck"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.knownAllergies')}
                id="pre-op-sign-in-knownAllergies"
                name="knownAllergies"
                data-cy="knownAllergies"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.airwayRisk')}
                id="pre-op-sign-in-airwayRisk"
                name="airwayRisk"
                data-cy="airwayRisk"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.bloodLoss')}
                id="pre-op-sign-in-bloodLoss"
                name="bloodLoss"
                data-cy="bloodLoss"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.bloodReserved')}
                id="pre-op-sign-in-bloodReserved"
                name="bloodReserved"
                data-cy="bloodReserved"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.documentsReady')}
                id="pre-op-sign-in-documentsReady"
                name="documentsReady"
                data-cy="documentsReady"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.equipmentReady')}
                id="pre-op-sign-in-equipmentReady"
                name="equipmentReady"
                data-cy="equipmentReady"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.implantReady')}
                id="pre-op-sign-in-implantReady"
                name="implantReady"
                data-cy="implantReady"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.active')}
                id="pre-op-sign-in-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.cursor')}
                id="pre-op-sign-in-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.lastupdated')}
                id="pre-op-sign-in-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.microSec')}
                id="pre-op-sign-in-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpSignIn.timestampentry')}
                id="pre-op-sign-in-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pre-op-sign-in-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.preOpSignIn.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-sign-in-anaesthesiologist"
                name="anaesthesiologist"
                data-cy="anaesthesiologist"
                label={translate('tinyMedicRestApp.preOpSignIn.anaesthesiologist')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-sign-in-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.preOpSignIn.nurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pre-op-sign-in" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PreOpSignInUpdate;
